import { RecipeFormValues } from '../models/form-values';
import { Action } from '@ngrx/store';
import { LocationSpecificationFormConfig } from '../models/location-specification-form-config';
import { ParameterResponse } from '@cemex-core/cmx-api';
import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { ModifyOnlineOrderState } from '@ordersnproducts/modules/new-modify-order/modules/new-modify-product-specification/reducers';

export enum LocationSpecificationActionTypes {
  INIT = '[Location Specification Specification] Init',
  RESET = '[Location Specification Specification] Reset',
  RESET_JOBSITE_SELECTION = '[Location Specification Specification] Reset jobsite',
  ADD_ITEM = '[Location Specification Specification] Add recipe item',
  DUPLICATE_ITEM = '[Location Specification Specification] Duplicate recipe item',
  UPDATE_ITEM = '[Location Specification Specification] Update recipe item',
  RESET_DATE_TIME = '[Location Specification Specification] Reset date & time',
  FETCH_ITEM_CONTRACTS = '[Location Specification] Fetch Item Contracts',
  STORE_ITEM_CONTRACTS = '[Location Specification] Store Item Contracts',
  OP_FETCH_UNITS = '[openPlatform - Unit] fetch volume units',
  OP_STORE_UNITS = '[openPlatform - Unit] store volume units',
  SET_ITEMS_SEQ_NUM = '[Location Specification Specification] Set items seq num',
  RESET_ITEMS_SEQ_NUM = '[Location Specification Specification] Reset items seq num',
  SET_ADDITIONAL_SERVICES = '[Location Specification Specification] Set additional services',
  SET_INVOICE_LOADED = '[Location Specification Specification] Set invoice loaded',
  REMOVE_ITEM = '[Location Specification Specification] Remove recipe item',
  LOCK_ITEM = '[Location Specification Specification] Lock recipe item',
  SET_FOR_DC_VALIDATION = '[Location Specification Specification] set for dc validation',
  SET_DC_VALIDATION = '[Location Specification Specification] set DC validation',
  SET_DIRTY = '[Location Specification Specification] set dirty',
  SET_INITIAL_LOAD = '[Location Specification Specification] set intial load',
  SET_FORM_VALID = '[Location Specification Specification] set valid',
  SET_RECEIVING_PERSON = '[Location Specification Specification] Set receiving person',
  NO_ACTION = '[Location Specification] Form No Action',
  SET_SPECIAL_INSTRUCTIONS_REQUEST = '[Location Specification] set special instructions request',
  SET_PURCHASE_ORDER_REQUEST = '[Location Specification] set purchase order request',
  SET_ORDER_ID = '[Location Specification] set order id',
  SET_CATALOG_FALSE = '[Location Specification] set catalog as false',
  SET_CONTACT_PERSON_FORM_CONFIG = '[Location Specification] Save add contact form-config for modal.',
  SET_LOCATION_SPECIFICATION_FROM_MODIFY = '[Location Specification] set state for modify summary.',
  SET_FORM_UPDATED_TIME = '[Location Specification] set form updated time.',
  SET_ERROR_ON_VALIDATION = '[Location Specification] error on order validation.',
  SET_PROCESSING_FORM = '[Location Specification] set processing form.',
  SET_ERRORS_MODAL = '[Location Specification] set show errors modals.',
  VALIDATE_FORMS = '[Location Specification] validate Forms.',
}

export class FetchItemContracts implements Action {
  readonly type = LocationSpecificationActionTypes.FETCH_ITEM_CONTRACTS;
  constructor(public payload: { productId: number; orderId: number }) {}
}

export class StoreItemContracts implements Action {
  readonly type = LocationSpecificationActionTypes.STORE_ITEM_CONTRACTS;
  constructor(public payload: { orderId: number; contracts: any[] }) {}
}

export class LocationSpecificationLoadAction implements Action {
  readonly type = LocationSpecificationActionTypes.INIT;

  constructor(public payload: LocationSpecificationFormConfig) {}
}

export class LocationSpecificationAddItemAction implements Action {
  readonly type = LocationSpecificationActionTypes.ADD_ITEM;

  constructor(public payload?: any) {}
}

export class LocationSpecificationDuplicateItemAction implements Action {
  readonly type = LocationSpecificationActionTypes.DUPLICATE_ITEM;

  constructor(public payload: { [key: string]: any }) {}
}

export class LocationSpecificationUpdateItemAction implements Action {
  readonly type = LocationSpecificationActionTypes.UPDATE_ITEM;

  constructor(
    public payload: {
      recipeFromValues: RecipeFormValues;
      previousValues: RecipeFormValues;
      isOnline: boolean;
      purchaseOrderValid: boolean;
      automaticValidation: boolean;
      enableCounterofferMatch: boolean;
    },
  ) {}
}

export class LocationSpecificationResetDateTimeAction implements Action {
  readonly type = LocationSpecificationActionTypes.RESET_DATE_TIME;
  constructor(public payload?: any) {}
}

export class LocationSpecificationSetItemsSeqAction implements Action {
  readonly type = LocationSpecificationActionTypes.SET_ITEMS_SEQ_NUM;

  constructor(public payload?: any) {}
}

export class LocationSpecificationResetItemsSeqAction implements Action {
  readonly type = LocationSpecificationActionTypes.RESET_ITEMS_SEQ_NUM;

  constructor(public payload?: any) {}
}

export class LocationSpecificationLockRecipeAction implements Action {
  readonly type = LocationSpecificationActionTypes.LOCK_ITEM;

  constructor(public payload: { orderFormId: number; locked: boolean; loadingInvoice: boolean }) {}
}

export class SetProcessingFormsAction implements Action {
  readonly type = LocationSpecificationActionTypes.SET_PROCESSING_FORM;

  constructor(public payload: { locked: boolean }) {}
}

export class SetShowErrorsModalAction implements Action {
  readonly type = LocationSpecificationActionTypes.SET_ERRORS_MODAL;

  constructor(public payload: { showErrorModal: boolean; allHaveError?: boolean }) {}
}

export class SetForRevalidateRecipeAction implements Action {
  readonly type = LocationSpecificationActionTypes.SET_FOR_DC_VALIDATION;

  constructor(public payload: { orderFormId: number; invokeDC: boolean; resetTime: boolean }) {}
}

export class SetForFormUpdateTime implements Action {
  readonly type = LocationSpecificationActionTypes.SET_FORM_UPDATED_TIME;

  constructor(public payload: { orderFormId: number; updatedTime: boolean }) {}
}

export class SetDirtyRecipeAction implements Action {
  readonly type = LocationSpecificationActionTypes.SET_DIRTY;

  constructor(public payload: { orderFormId?: number; dirty?: boolean; dirtyAll?: boolean }) {}
}

export class SetErrorAction implements Action {
  readonly type = LocationSpecificationActionTypes.SET_ERROR_ON_VALIDATION;

  constructor(public payload: { orderFormId?: number; hasError?: boolean }) {}
}

export class SetInitialLoadAction implements Action {
  readonly type = LocationSpecificationActionTypes.SET_INITIAL_LOAD;

  constructor(public payload: { orderFormId?: number; isInitialLoadAll?: boolean }) {}
}

export class SetDCValidationRecipeAction implements Action {
  readonly type = LocationSpecificationActionTypes.SET_DC_VALIDATION;

  constructor(public payload: { orderFormId: number; DCResponse: ParameterResponse }) {}
}

export class SetValidRecipeAction implements Action {
  readonly type = LocationSpecificationActionTypes.SET_FORM_VALID;

  constructor(public payload: { orderFormId?: number; formValid?: boolean; formValidAll?: boolean }) {}
}

export class LocationSpecificationRemoveItemAction implements Action {
  readonly type = LocationSpecificationActionTypes.REMOVE_ITEM;

  constructor(public payload: number) {}
}

export class LocationSpecificationSetInvoiceLoadedAction implements Action {
  readonly type = LocationSpecificationActionTypes.SET_INVOICE_LOADED;

  constructor(public payload: boolean) {}
}

export class LocationSpecificationResetAction implements Action {
  readonly type = LocationSpecificationActionTypes.RESET;

  constructor(public payload?: any) {}
}

export class LocationSpecificationResetJobsiteSelectionAction implements Action {
  readonly type = LocationSpecificationActionTypes.RESET_JOBSITE_SELECTION;

  constructor(public payload?: any) {}
}

export class LocationSpecificationSetSpecialInstructionsRequest implements Action {
  readonly type = LocationSpecificationActionTypes.SET_SPECIAL_INSTRUCTIONS_REQUEST;

  constructor(public payload: string) {}
}

export class LocationSpecificationSetPurchaseOrderRequest implements Action {
  readonly type = LocationSpecificationActionTypes.SET_PURCHASE_ORDER_REQUEST;

  constructor(public payload: string) {}
}

export class LocationSpecificationSetOrderId implements Action {
  readonly type = LocationSpecificationActionTypes.SET_ORDER_ID;

  constructor(public payload: { orderFormId: number; orderId: number }) {}
}
export class LocationSpecificationSetReceivingPersonAction implements Action {
  readonly type = LocationSpecificationActionTypes.SET_RECEIVING_PERSON;
  // payload = receiving person contactId
  constructor(public payload: number) {}
}

export class LocationSpecificationCatalogFalse implements Action {
  readonly type = LocationSpecificationActionTypes.SET_CATALOG_FALSE;
  constructor(public payload?: any) {}
}

export class SetContactPersonFormConfig implements Action {
  readonly type = LocationSpecificationActionTypes.SET_CONTACT_PERSON_FORM_CONFIG;
  constructor(public payload: FieldConfig[]) {}
}

export class SetLocationSpecificationModify implements Action {
  readonly type = LocationSpecificationActionTypes.SET_LOCATION_SPECIFICATION_FROM_MODIFY;
  constructor(public payload: ModifyOnlineOrderState) {}
}

export class NoAction implements Action {
  readonly type = LocationSpecificationActionTypes.NO_ACTION;
  constructor(public payload?: any) {}
}

export class ValidateForms implements Action {
  readonly type = LocationSpecificationActionTypes.VALIDATE_FORMS;
  constructor(public payload: { formId?: number }) {}
}

export type LocationSpecificationActions =
  | LocationSpecificationLoadAction
  | LocationSpecificationResetAction
  | LocationSpecificationAddItemAction
  | LocationSpecificationDuplicateItemAction
  | LocationSpecificationUpdateItemAction
  | LocationSpecificationResetDateTimeAction
  | LocationSpecificationSetItemsSeqAction
  | LocationSpecificationResetItemsSeqAction
  | LocationSpecificationSetInvoiceLoadedAction
  | LocationSpecificationRemoveItemAction
  | FetchItemContracts
  | StoreItemContracts
  | LocationSpecificationLockRecipeAction
  | LocationSpecificationResetJobsiteSelectionAction
  | SetForRevalidateRecipeAction
  | SetDCValidationRecipeAction
  | LocationSpecificationSetReceivingPersonAction
  | SetDirtyRecipeAction
  | SetInitialLoadAction
  | LocationSpecificationSetSpecialInstructionsRequest
  | LocationSpecificationSetPurchaseOrderRequest
  | LocationSpecificationSetOrderId
  | LocationSpecificationCatalogFalse
  | SetContactPersonFormConfig
  | SetLocationSpecificationModify
  | SetValidRecipeAction
  | SetForFormUpdateTime
  | SetErrorAction
  | SetProcessingFormsAction
  | SetShowErrorsModalAction
  | NoAction;
